// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/spotlight.css
// module id = 4161
// module chunks = 0